import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { Box, Button } from "@mui/material";
import apiManagerUser from "api/manager-users";
import OtpDialog from "components/Dialog/OtpDialog";
import { ERROR } from "pages/authentication/components/constant";
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from "react-redux";
import { setCloseModal, setOpenModal } from "store/modal/modalSlice";
import { setEmail, setExpireTimeOTP } from "store/user/accountInfo";
import { TOAST_DEFAULT } from "constants/toast";
import { toastError, toastSuccess } from "utils/helpers";
import { ReactComponent as VerifyMailIcon } from "../../assets/svg/verifyEmail.svg";

export default function VerifyEmail({checkClose}){
    const dispatch = useDispatch();
    const {t} = useTranslation()
    const accountInfo = useSelector((state) => state.accountInfo);
    const userInfo = useSelector((state) => state.userInfo.userInfo);

    const sendOTP = (email, page) => {
        return apiManagerUser.sendOTP(email, page, undefined, undefined, 1)
    }

    const verifyMail = (email, beforeEmail, otp) => {
        return apiManagerUser.verifyMail(email, beforeEmail, otp)
    }

    const handleSubmitVerifyOtp = (emailAccount, beforeEmailAccount, otp) => {
        verifyMail(accountInfo?.email, '', otp)
            .then(res => {
                toastSuccess(t('toast.verifiedEmail'));
                dispatch(setCloseModal());
            })
            .catch(error => {
                if(error.response.data.detail.countDown){
                    let totalSeconds = error.response.data.detail.countDown
                    let hours = Math.floor(totalSeconds / 3600);
                    totalSeconds %= 3600;
                    let minutes = Math.floor(totalSeconds / 60);
                    let seconds = totalSeconds % 60;
                    const timeChangePwd = `${t('toast.subChangePwd')} ${hours ? t('toast.subHours', { hour: hours }) : ''}${
                        minutes || hours ? t('toast.subMinutes', { minute: minutes }) : ''
                    }${seconds && minutes === 0 && hours === 0 ? t('toast.subSeconds', { second: seconds }) : ''}`;
                    toastError(timeChangePwd);
                    dispatch(setCloseModal());
                } else {
                    toastError(t(TOAST_DEFAULT.ERROR))
                    dispatch(setCloseModal());
                }
            })
    }

    const handleChangeEmail = () => {
        dispatch(setCloseModal());
        dispatch(setOpenModal({ modal: <OtpDialog componentRender={3} checkClose={checkClose}/> , alwayClose: checkClose ? false : true}))
    }

    const handleClick = () => {
        dispatch(setCloseModal());
        setTimeout(() => {
            sendOTP(accountInfo?.email, "verify-email")
                    .then(r => {
                        toastSuccess(t('toast.sendOTPSuccess'));
                        dispatch(setExpireTimeOTP(r.timeExpire));
                        dispatch(setEmail(accountInfo?.email));
                        dispatch(setOpenModal({ modal: <OtpDialog onSubmitVerifyOtp={handleSubmitVerifyOtp} checkClose={true} pageSentOtp="verify-email"/> , alwayClose: checkClose ? false : true}))          
                    })
                    .catch(error => {
                        if(error?.response?.data?.detail === ERROR.MAX_FORGOT_ACCOUNT){
                        toastError(t('auth.ERROR.MAX_FORGOT_ACCOUNT'))
                        } else if(error?.response?.data?.detail === ERROR.MAX_FORGOT_DEVICE){
                            toastError(t('auth.ERROR.MAX_FORGOT_DEVICE'))
                        } else if(error?.response?.data?.detail === ERROR.NO_EMAIL){
                            toastError(t('auth.ERROR.NO_EMAIL'));
                        } else toastError(TOAST_DEFAULT.ERROR);
                    });
        }, [200])
    }

    return(
        <Box sx={{display: 'flex', flexDirection: 'column', justifyContent:'center', padding: {md: '0.5rem 0rem', xl: (localStorage?.getItem(`timeVerifyEmail_${userInfo?.username}`) || !(userInfo?.verifyMail && !userInfo?.timeMustVerifyMail)) ? '1rem 0rem' : '1rem 3rem'}}}>
            <VerifyMailIcon style={{margin: 'auto'}}/>
            <Box sx={{margin: 'auto', fontWeight: '700', color: '#44494D', fontSize: {xs: '18px', md: '24px'}, marginTop: '20px'}}>{t('popup.verify-email.title')}</Box>
            <div style={{margin: 'auto', marginTop: '10px', marginBottom: '10px', display: 'flex', alignItems: 'center', color: '#44494D'}}><ErrorOutlineOutlinedIcon sx={{fontSize: '14px', marginRight: '5px', color: '#D66905'}}/> {(localStorage?.getItem(`timeVerifyEmail_${userInfo?.username}`) || !(userInfo?.verifyMail && !userInfo?.timeMustVerifyMail)) ? t('popup.verify-email.content') : t('popup.verify-email.first-content')}</div>
            <Button style={{margin: '30px auto 0', backgroundColor: '#ee0033', maxWidth: '320px'}} className="mb-3 w-full" onClick={handleClick} >
                {t('popup.verify-email.button')}
            </Button>
            <div style={{margin: 'auto', marginTop: '10px', marginBottom: '10px', color: '#44494D'}}>{t('popup.verify-email.used-email')} <span style={{fontWeight: '700', wordBreak: 'break-all'}}>{accountInfo?.email}</span>.</div>
            <div style={{margin: 'auto', marginTop: '0px', marginBottom: '10px', color: '#44494D'}}>{t('popup.verify-email.change-email')} <span style={{fontWeight: '700', color: '#ee0033', cursor: 'pointer', textDecoration: 'underline'}} tabIndex={0} onKeyDown={e => {if(e.key === "Enter")handleChangeEmail()}} onClick={handleChangeEmail}>{t('popup.verify-email.click')}</span></div>
        </Box>
    )
}